import React from 'react';
import { connect } from 'react-redux';
import { signIn, signOut, userName, userDetails, messageAsanas, Singauth, popupBot, newUsers, newUserDetails, userUtils } from '../../actions';
import history from '../../history';
//import '../../components/styles/ingresoHupity.css';
import firebase from 'firebase';
import axios from 'axios';
import moment from 'moment';
import { ListGroup, Row, Image, Col, Button } from 'react-bootstrap';
import { clientIdAsana, clientSecrectAsana, clientSlack, clientSecrectSlack, clientIdGoogle, apiKeyGoogle } from '../../apis/stringConnection';
import { etapaHupper, dataBaseManager } from '../hupUtils/utils';
//var qs = require('qs') // query params;

import dialog from '../../apis/dialog';
import { location, projectId, agentId } from '../../apis/stringConnection';

const timeoutLength = 5000;
const timeoutLength2 = 2000;


const LANGUAGE_CODE = 'en-US'


const languageCode = 'en';

let scope = "https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/dialogflow"

class GoogleAuth extends React.Component {

    state = { selectedFile: null, loaded: 0, codigo: null, direccion: null, tokenTrello: false, uid: null }



    componentDidMount() {

        window.gapi.load('client:auth2', () => {
            window.gapi.client.init({
                clientId: clientIdGoogle,
                apiKey: apiKeyGoogle,
                discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest", "https://dialogflow.googleapis.com/$discovery/rest?version=v3"],
                scope
            }).then(() => {
                this.auth = window.gapi.auth2.getAuthInstance();
                this.props.Singauth(this.auth);
                this.onAuthChange(this.auth.isSignedIn.get());
                this.auth.isSignedIn.listen(this.onAuthChange);





            });

        });

    }

    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }

    //borrar cuando termine
    async detectIntentText(query, tok) {

        let body = {
            "queryInput": {
                "text": {
                    "text": query
                },
                languageCode: languageCode
            },
        };
        const sessionId = Math.random().toString(36).substring(7);
        const t = `https://us-central1-dialogflow.googleapis.com/v3/projects/${projectId}/locations/${location}/agents/${agentId}/sessions/${sessionId}:detectIntent`;




        const token = 'Bearer ' + tok;

        console.log(token);

        const message = axios.post(t, body, {
            headers: {

                "Authorization": token,
                "ContentType": "application/json; charset=utf-8"
            },


        }).then(res => {
            console.log(res.data.queryResult.responseMessages[0].text.text[0]);
            //return res.data.queryResult.responseMessages[0].text.text[0];
        }
        ).catch(err => {
            console.log(err);
            // return ""
        })
        return message;
    };


    renderValidAsana = (Usuario) => {

        this.timeout = setTimeout(() => {

            const starCountRef = this.componentDatabase("get", `Usuario-CodeTemporal/${this.state.uid}`);
            let us = this.state.uid;
            starCountRef.on('value', (snapshot) => {
                const cod = snapshot.val();
                if (cod) {
                    let code = cod.code;
                    if (cod.asana) {
                        code = code.replace('%2F', '/').replace('%3A', ':');
                        axios.post(`https://cors-anywhere.herokuapp.com/https://app.asana.com/-/oauth_token`, null, {
                            params: {
                                'grant_type': 'authorization_code',
                                'client_id': clientIdAsana, 'client_secret': clientSecrectAsana,
                                'redirect_uri': window.location.origin, code
                            }
                        }).then(res => {

                            //  const starCountRef = 
                            let objectAr = {
                                token: res.data.access_token,
                                rToken: res.data.refresh_token,
                                code
                            }
                            this.componentDatabase("update", `Usuario-Asana/${this.state.uid}`, objectAr, 'Hemos actualizado correctamente tu usuario', 'default');
                            this.props.messageAsanas('Asana');
                            this.renderBorrarAsana(us);
                            history.push('/profile');

                        }
                        ).catch(err => console.log(err))
                    }
                    else {
                        axios.get(`https://slack.com/api/oauth.access?client_id=${clientSlack}&redirect_uri=${window.location.origin}&client_secret=${clientSecrectSlack}&code=${code}`)
                            .then((res, tres) => {
                                if (res.data.bot) {

                                    let objectAr = {
                                        tokenSlack: res.data.access_token,
                                        tokenBot: res.data.bot.bot_access_token,
                                        userSlack: res.data.user_id
                                    }
                                    this.componentDatabase("insert", `Usuario-Slack/${this.state.uid}`, objectAr, 'Hemos actualizado correctamente tu usuario', 'default');
                                    objectAr = {
                                        userSlack: res.data.user_id
                                    }
                                    this.componentDatabase("update", `Usuario/${this.state.uid}`, objectAr, 'Hemos actualizado correctamente tu usuario', 'default');
                                    this.props.messageAsanas('Slack');
                                    history.push('/profile');
                                }
                            });
                    }
                }
            })
        }, timeoutLength2)
    }


    renderBorrarAsana = (Usuario) => {
        this.timeout = setTimeout(() => {
            this.componentDatabase("insert", `Usuario-CodeTemporal/${this.stateuid}`, {});
        }, timeoutLength)
    }

    validaCodigoAcc = (Usuario) => {
        this.timeout = setTimeout(() => {


            const starCountRef = this.componentDatabase("get", `Codigo-Acceso/${Usuario.codigo}`);
            starCountRef.on('value', (snapshot) => {
                const cod = snapshot.val();
                if (cod) {
                    if (cod.estado === 'usado') {
                        if (moment().diff(moment(cod.fechaUso, 'YYYY-MM-DD'), 'days') > 180) {
                            cod.estado = 'usado';
                            const us = Usuario;
                            us.estado = 'inactivo';
                            us.onboarding = true;

                            let objectAr = {
                                ...cod,
                                fechaTer: new Date().toString(),
                            }
                            this.componentDatabase("insert", `Codigo-Acceso/${Usuario.codigo}`, objectAr, 'Hemos actualizado correctamente tu usuario', 'default');
                            this.componentDatabase("insert", `Usuario/${this.state.uid}`, { ...us }, 'Hemos actualizado correctamente tu usuario', 'default');
                            this.auth.signOut();
                        }
                    }
                }
            })
        }, timeoutLength)
    }

    createUsuario() {

        let direccion = '/formulario';
        //   console.log(this.auth.currentUser.get().getBasicProfile().getEmail());
        let usuarioNuevo = { nombre: this.auth.currentUser.get().getBasicProfile().getName(), email: this.auth.currentUser.get().getBasicProfile().getEmail(), id: this.auth.currentUser.get().getId(), rol: '2', userId: this.auth.currentUser.get().getId() };
        this.props.userDetails({ usuarioNuevo });

        const starCountRef = this.componentDatabase("get", `Usuario-Temporal/${this.state.uid}`);
        starCountRef.on('value', (snapshot) => {

            if (snapshot.val()) {
                const starCountRef2 = this.componentDatabase("get", `Usuario-CodeTemporal/${this.state.uid}`);
                starCountRef2.on('value', (snapshot2) => {

                    if (snapshot2.val()) {
                        this.props.newUserDetails({ ...snapshot.val(), recupero: true, codeSlack: snapshot2.val().code });
                        direccion = '/formulario/herramientas';
                        history.push(direccion);
                    }
                });
            }
            history.push(direccion);
        });
    }
    renderUsarioLogin(uid) {
        this.props.signIn(uid);
        const nameRef = this.componentDatabase("get", `Usuario/${uid}`);
        nameRef.on('value', (snapshot) => {

            const Usuario = snapshot.val();
            this.props.userUtils({ ...this.props.userUtil, nombre: Usuario.usuario });
            this.props.userUtils({ ...this.props.userUtil, userId: uid });
            this.props.userUtils({ ...this.props.userUtil, empresa: Usuario.empresa });
            this.props.userUtils({ ...this.props.userUtil, equipo: Usuario.equipo });
            //invalida codigo de acceso
            if (Usuario) {
                let etapa = etapaHupper(Usuario, uid, `/Utils/Hupper`)
                if (Usuario.codigo) {
                    if (Usuario.estado === 'activo')
                        this.validaCodigoAcc(Usuario);
                    else ///puedo hacer la reactivacion dependiendo. ****************Importante                  
                        this.auth.signOut();
                }

                let slack = null;
                //obtien la configuracion de slack
                const nameRef4 = this.componentDatabase("get", `Usuario-Slack/${uid}`);
                nameRef4.on('value', (snapshot3) => {
                    if (snapshot3.val())
                        slack = snapshot3.val();
                });

                let calendar = null;
                const nameRef5 = this.componentDatabase("get", `Usuario-CalendarGoogle/${uid}`);
                nameRef5.on('value', (snapshot) => {
                    if (snapshot.val()) {
                        calendar = snapshot.val().idCalendar.value;
                    }
                });

                let rol = null;
                const nameRef2 = this.componentDatabase("get", `Usuario-Rol/${uid}`);
                nameRef2.on('value', (snapshot2) => {
                    rol = snapshot2.val().Rol;
                });


                const nameRef3 = this.componentDatabase("get", `Usuario-WS/${Usuario.empresa}/${Usuario.equipo}/${uid}`);
                nameRef3.on('value', (snapshot3) => {
                    if (snapshot3.val()) {

                        this.props.userDetails({ usuario: Usuario, calendar, idUsuario: uid, id: this.auth.currentUser.get().getId(), linkws: snapshot3.val().linkWs, slack, rol, etapa });
                    }
                });
            }
            else {
                this.createUsuario();
            }
        });
    }

    onAuthChange = isSignedIn => {
        // console.log(this.auth);



        if (isSignedIn) {




            let objectId = { email: this.auth.currentUser.get().getBasicProfile().getEmail(), ID: this.auth.currentUser.get().getId() }
            this.componentDatabase("login", null, objectId);
            this.props.newUsers(true);

            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.setState({ uid: this.auth.currentUser.get().getId() });
                    this.props.userName(this.auth.currentUser.get().getBasicProfile().getName());
                    //recupera codigo de acceso de slack
                    this.recuperarDatoSlack(this.auth.currentUser.get().getId());
                    //recupera el token trello
                    this.recuperarDatoToken(this.auth.currentUser.get().getId());
                    //render valida si el usuario se ha creado en Asana
                    this.renderValidAsana();
                    //Encuentra el Rol,
                    this.renderUsarioLogin(this.auth.currentUser.get().getId());
                    // User is signed in.
                } else {
                    this.createUsuario();
                    this.props.popupBot({ mensaje: "vamos a comenzar crenado tu usuario" });
                    // No user is signed in.
                }
            })

        } else {
            this.props.signOut();
        }
    };

    recuperarDatoSlack(uid) {

        const querystring = window.location.search;
        if (querystring) {
            let asana = false;
            if (querystring.includes('asana'))
                asana = true;
            const params = new URLSearchParams(querystring);
            let code = params.get('code');
            this.setState({ code });
            this.componentDatabase("insert", `Usuario-CodeTemporal/${uid}`, { code, asana });
            return code;
        }

    }

    recuperarDatoToken(uid) {


        const querystring = window.location.search;
        if (querystring) {
            const params = new URLSearchParams(querystring);
            let token = params.get('token');
            this.setState({ token });
            this.componentDatabase("insert", `Usuario-CodeTemporal/${uid}`, { token });
            return token;
        }
    }



    componentDidUpdate() {
        if (this.props.nuevoUsuario === false)
            this.auth.signOut();
    }

    onSignInClick = () => {

        this.auth.signIn();
    };
    onSignOutClick = () => {
        this.auth.signOut();
        history.push('/');
    };

    renderAuthButton() {

        //click entra o sale
        if (this.props.isSignedIn === null) {
            return null;
        }
        else if (this.props.isSignedIn) {

            if (this.state.tokenTrello === true)
                history.push('/proceso/exito');

            return (
                <Row >
                    <Col >
                        <ListGroup  >
                            <ListGroup.Item action variant="light" style={{ borderRadius: '10px' }} onClick={() => { this.onSignOutClick() }} >
                                <Image className='image-enable' alt='Ingresa a Hupity con Google' src="https://cdn.goconqr.com/assets/social/google/btn_google_light_normal_ios_160-9ef927f3fdc8ade894b35a0eb01225e8602967d799a831565f9327840aaaf44c.png" roundedCircle />
                                Sign Out
                                </ListGroup.Item>
                        </ListGroup>
                    </Col>
                </Row>
            );
        }
        else {

            history.push('/');
            if (this.props.googleIn) {
                return (
                    <div style={{ height: '1.2em' }}>
                        <i className="google icon"></i>

                        <ListGroup>
                            <ListGroup.Item action variant="light">
                                Tu cuenta Google
                            </ListGroup.Item>
                        </ListGroup>

                    </div>
                );
            }
            else {

                return (


                    <Row >
                        <Col >
                            <Button variant="info" className= 'bluex'style={{borderRadius: '10px' }} onClick={() => { this.onSignInClick(); }} active>
                                <Image className='image-able' alt='Ingresa a Hupity con Google' src="https://cdn.goconqr.com/assets/social/google/btn_google_light_normal_ios_160-9ef927f3fdc8ade894b35a0eb01225e8602967d799a831565f9327840aaaf44c.png" roundedCircle />
                                Sign in wiht Google
                            </Button>
                        </Col>
                    </Row>




                );
            }
        }
    }

    render() {
        return <div>{this.renderAuthButton()}</div>
    }
};

const mapStateToProps = (state) => {
    return {
        isSignedIn: state.mainReducer.isSignedIn,
        newUser: state.mainReducer.newUser,
        userDetail: state.mainReducer.userDetail,
        userUtil: state.mainReducer.userUtil,
    };
};
export default connect(mapStateToProps, { userUtils, signIn, signOut, userName, userDetails, popupBot, newUsers, newUserDetails, messageAsanas, Singauth })(GoogleAuth);
